import type { ShopRootExpertsExploreCurationClicked } from '@apps/registry/common/components/Catalog/Catalog.telemetry.types';
import type { ButtonV2Props } from '@withjoy/joykit';
import { ButtonV2 } from '@withjoy/joykit';
import { ReactComponent as ArrowIcon } from './icons/arrow-right.svg';
import React from 'react';

interface CustomCtaProps extends ButtonV2Props {
  method: ShopRootExpertsExploreCurationClicked['method'];
  buttonText: string;
  isPlainText?: boolean;
}

const CustomCta = (props: CustomCtaProps) => {
  const { method, buttonText, isPlainText, ...restProps } = props;

  return (
    <>
      {isPlainText ? (
        <ButtonV2
          variant="ghost"
          data-method={method}
          endIcon={<ArrowIcon />}
          {...restProps}
          paddingX={0}
          _hover={{ backgroundColor: 'transparent !important' }}
        >
          {buttonText}
        </ButtonV2>
      ) : (
        <ButtonV2
          variant="outline"
          borderColor="white"
          data-method={method}
          {...restProps}
        >
          {buttonText}
        </ButtonV2>
      )}
    </>
  );
};
export { CustomCta };
